import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/contractor/login/page.tsx");
